document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('.main-product-section');
  if (!sections.length) {
    return;
  }

  const parseMoney = function (value) {
    if (typeof value !== 'number') {
      return 0;
    }

    return value / 100;
  };

  const formatMoney = function (value) {
    const currencyCode = window?.Shopify?.currency?.active || 'USD';
    const safeValue = Number.isFinite(value) ? value : 0;

    if (currencyCode === 'CAD') {
      return `CAD $${safeValue.toFixed(2)}`;
    }

    return new Intl.NumberFormat(currencyCode === 'INR' ? 'en-IN' : 'en', {
      style: 'currency',
      currency: currencyCode,
      currencyDisplay: currencyCode === 'CAD' ? 'symbol' : 'narrowSymbol'
    }).format(safeValue);
  };

  const parsePackQty = function (packText) {
    if (typeof packText !== 'string') {
      return 1;
    }

    const match = packText.match(/\d+/);
    if (match && match[0]) {
      const qty = parseInt(match[0], 10);
      if (qty > 0) {
        return qty;
      }
    } else {
      return 1;
    }

    return 1;
  };

  const formatPackPrice = function (value) {
    return `${formatMoney(value)} ea.`;
  };

  const initSection = function (section) {
    const productDataId = section.getAttribute('data-product-data-id');
    const productOptionsDataId = section.getAttribute('data-product-options-data-id');
    const discountPercent = Number(section.getAttribute('data-discount-percent')) || 20;
    const discountMultiplier = Math.max(0, 1 - discountPercent / 100);

    const productDataNode = productDataId ? document.getElementById(productDataId) : null;
    const productOptionsNode = productOptionsDataId ? document.getElementById(productOptionsDataId) : null;

    if (!productDataNode || !productOptionsNode) {
      return;
    }

    let productData = null;
    let productOptions = null;

    try {
      productData = JSON.parse(productDataNode.textContent || '{}');
      productOptions = JSON.parse(productOptionsNode.textContent || '[]');
    } catch (error) {
      console.error('main-product: unable to parse product JSON', error);
      return;
    }

    const styleButtons = section.querySelectorAll('[data-style-value]');
    const oneTimeCard = section.querySelector('[data-plan-card="one-time"]');
    const subscribeCard = section.querySelector('[data-plan-card="subscribe"]');
    const oneTimeDetails = section.querySelector('[data-plan-details="one-time"]');
    const subscribeDetails = section.querySelector('[data-plan-details="subscribe"]');
    const oneTimePackOptions = section.querySelector('[data-pack-options="one-time"]');
    const subscribePackOptions = section.querySelector('[data-pack-options="subscribe"]');
    const planToggleButtons = section.querySelectorAll('[data-plan-toggle]');
    const oneTimeIndicator = section.querySelector('[data-plan-indicator="one-time"]');
    const subscribeIndicator = section.querySelector('[data-plan-indicator="subscribe"]');
    const oneTimeHeaderPrice = section.querySelector('[data-plan-price="one-time"]');
    const subscribeHeaderPrice = section.querySelector('[data-plan-price="subscribe"]');
    const subscribeHeaderComparePrice = section.querySelector('[data-plan-price-compare="subscribe"]');
    const subscribeHeaderRegularPrice = section.querySelector('[data-plan-price-regular="subscribe"]');
    const hiddenVariantInput = section.querySelector('[data-hidden-variant-id]');
    const hiddenSellingPlanInput = section.querySelector('[data-hidden-selling-plan-id]');
    const saveRow = section.querySelector('[data-save-row]');
    const priceLabel = section.querySelector('.main-product-price-label');
    const priceCompare = section.querySelector('.main-product-price-compare');
    const priceBadge = section.querySelector('.main-product-price-badge');
    const priceMain = section.querySelector('.main-product-price-main');
    const priceTop = section.querySelector('.main-product-price-top');
    const form = section.querySelector('[data-main-product-form]');
    const frequencySelect = section.querySelector('[data-subscribe-frequency]');
    const frequencyWrapper = section.querySelector('[data-frequency-wrapper]');

    const mainGallery = section.querySelector('.main-product-gallery-main');
    const thumbsGallery = section.querySelector('.main-product-gallery-thumbs');
    const mainSlides = section.querySelector('[data-main-gallery-slides]');
    const thumbSlides = section.querySelector('[data-thumb-gallery-slides]');
    const galleryPrev = section.querySelector('.main-product-gallery-prev');
    const galleryNext = section.querySelector('.main-product-gallery-next');

    const variants = Array.isArray(productData?.variants) ? productData.variants : [];
    const styleValues = Array.isArray(productOptions?.[0]?.values) ? productOptions[0].values : [];
    const packValues = Array.isArray(productOptions?.[1]?.values) ? productOptions[1].values : [];
    const hasSellingPlans = Array.isArray(productData?.selling_plan_groups) && productData.selling_plan_groups.length > 0;
    const oneTimePackButtons = oneTimePackOptions ? oneTimePackOptions.querySelectorAll('[data-pack-value]') : [];
    const subscribePackButtons = subscribePackOptions ? subscribePackOptions.querySelectorAll('[data-pack-value]') : [];

    let selectedStyle = styleButtons?.[0]?.getAttribute('data-style-value') || styleValues[0] || '';
    let selectedPack = packValues[0] || '';
    let selectedPlan = hasSellingPlans ? 'subscribe' : 'one-time';
    let mainSwiper = null;
    let thumbsSwiper = null;

    const defaultPackRaw = section.querySelector('[data-default-variant]')?.getAttribute('data-default-variant');
    if (defaultPackRaw) {
      const expected = `${defaultPackRaw} Pack`;
      if (packValues.includes(expected)) {
        selectedPack = expected;
      }
    } else {
      selectedPack = packValues.includes('2 Pack') ? '2 Pack' : selectedPack;
    }

    const findVariant = function (style, pack) {
      return variants.find(function (variant) {
        const matchesStyle = style ? variant.option1 === style : true;
        const matchesPack = pack ? variant.option2 === pack : true;
        return matchesStyle && matchesPack;
      }) || null;
    };

    const getOnePackBasePrice = function (style) {
      const onePackVariant = findVariant(style, '1 Pack');
      if (onePackVariant && typeof onePackVariant.price === 'number') {
        return parseMoney(onePackVariant.price);
      }

      const fallbackVariant = findVariant(style, selectedPack);
      if (fallbackVariant) {
        const qty = parsePackQty(selectedPack);
        return parseMoney(fallbackVariant.price) / qty;
      }

      return 0;
    };

    const syncStyleButtons = function () {
      styleButtons.forEach(function (button) {
        const value = button.getAttribute('data-style-value');
        if (value === selectedStyle) {
          button.classList.add('is-active');
        } else {
          button.classList.remove('is-active');
        }
      });
    };

    const syncPlanUI = function () {
      if (oneTimeCard && subscribeCard && oneTimeDetails && subscribeDetails) {
        if (selectedPlan === 'subscribe') {
          oneTimeCard.classList.remove('is-active');
          subscribeCard.classList.add('is-active');
          oneTimeDetails.classList.add('hidden');
          subscribeDetails.classList.remove('hidden');
          oneTimeIndicator?.classList.remove('is-active');
          subscribeIndicator?.classList.add('is-active');
          frequencyWrapper?.classList.remove('hidden');
        } else {
          oneTimeCard.classList.add('is-active');
          subscribeCard.classList.remove('is-active');
          oneTimeDetails.classList.remove('hidden');
          subscribeDetails.classList.add('hidden');
          oneTimeIndicator?.classList.add('is-active');
          subscribeIndicator?.classList.remove('is-active');
          frequencyWrapper?.classList.remove('hidden');
        }
      } else {
        return;
      }
    };

    const syncPackOptions = function () {
      if (!oneTimePackButtons.length || !subscribePackButtons.length || !packValues.length) {
        return;
      }

      const syncPackContainer = function (buttons, isSubscribe) {
        buttons.forEach(function (button) {
          const pack = button.getAttribute('data-pack-value') || '';
          const variant = findVariant(selectedStyle, pack);
          const priceNode = button.querySelector('[data-pack-price]');
          if (!variant || !priceNode) {
            button.classList.add('hidden');
            return;
          }

          const qty = parsePackQty(pack);
          const unitPrice = parseMoney(variant.price) / qty;
          const displayPrice = isSubscribe ? unitPrice * discountMultiplier : unitPrice;
          priceNode.textContent = formatPackPrice(displayPrice);

          button.classList.remove('hidden');
          if (pack === selectedPack) {
            button.classList.add('is-active');
          } else {
            button.classList.remove('is-active');
          }
        });
      };

      syncPackContainer(oneTimePackButtons, false);
      syncPackContainer(subscribePackButtons, true);
    };

    const updatePriceArea = function () {
      const variant = findVariant(selectedStyle, selectedPack);
      if (!variant) {
        return;
      }

      const qty = parsePackQty(selectedPack);
      const onePackBasePrice = getOnePackBasePrice(selectedStyle);
      const oneTimeTotalPrice = parseMoney(variant.price);
      const oneTimeCompareTotalPrice = onePackBasePrice * qty;
      const subscribeTotalPrice = oneTimeTotalPrice * discountMultiplier;
      const oneTimeCalculatedPercent = oneTimeCompareTotalPrice > 0 && oneTimeTotalPrice > 0
        ? Math.round(((oneTimeCompareTotalPrice - oneTimeTotalPrice) / oneTimeCompareTotalPrice) * 100)
        : 0;
      const subscribeCalculatedPercent = oneTimeCompareTotalPrice > 0 && subscribeTotalPrice > 0
        ? Math.round(((oneTimeCompareTotalPrice - subscribeTotalPrice) / oneTimeCompareTotalPrice) * 100)
        : discountPercent;

      if (oneTimeHeaderPrice) {
        oneTimeHeaderPrice.textContent = formatMoney(oneTimeTotalPrice);
      } else {
        return;
      }

      if (subscribeHeaderPrice) {
        if (subscribeHeaderRegularPrice && subscribeHeaderComparePrice) {
          subscribeHeaderRegularPrice.textContent = formatMoney(subscribeTotalPrice);
          subscribeHeaderComparePrice.textContent = formatMoney(oneTimeCompareTotalPrice);
          subscribeHeaderComparePrice.classList.remove('hidden');
        } else {
          subscribeHeaderPrice.textContent = formatMoney(subscribeTotalPrice);
        }
      } else {
        return;
      }

      if (selectedPlan === 'subscribe') {
        if (priceCompare && priceBadge && priceMain && priceLabel && priceTop) {
          priceLabel.textContent = 'Original Marketplace Price';
          priceCompare.textContent = formatMoney(oneTimeCompareTotalPrice);
          priceCompare.classList.remove('hidden');
          priceTop.classList.remove('hidden');
          priceBadge.textContent = `${subscribeCalculatedPercent}% OFF`;
          priceBadge.classList.remove('hidden');
          priceBadge.classList.add('inline-flex');
          priceMain.textContent = formatMoney(subscribeTotalPrice);
        } else {
          return;
        }
      } else {
        if (priceCompare && priceBadge && priceMain && priceLabel && priceTop) {
          priceLabel.textContent = 'Original Marketplace Price';
          priceTop.classList.remove('hidden');
          if (oneTimeCompareTotalPrice > oneTimeTotalPrice) {
            priceCompare.textContent = formatMoney(oneTimeCompareTotalPrice);
            priceCompare.classList.remove('hidden');
            priceBadge.textContent = `${oneTimeCalculatedPercent}% OFF`;
            priceBadge.classList.remove('hidden');
            priceBadge.classList.add('inline-flex');
          } else {
            priceCompare.textContent = '';
            priceCompare.classList.add('hidden');
            priceBadge.classList.add('hidden');
            priceBadge.classList.remove('inline-flex');
          }
          priceMain.textContent = formatMoney(oneTimeTotalPrice);
        } else {
          return;
        }
      }

      if (hiddenVariantInput) {
        hiddenVariantInput.value = String(variant.id);
      } else {
        return;
      }

      if (saveRow) {
        let saving = 0;
        if (selectedPlan === 'subscribe') {
          saving = oneTimeCompareTotalPrice - subscribeTotalPrice;
        } else if (oneTimeCompareTotalPrice > oneTimeTotalPrice) {
          saving = oneTimeCompareTotalPrice - oneTimeTotalPrice;
        } else {
          saving = 0;
        }

        if (saving > 0) {
          saveRow.textContent = `YOU SAVE ${formatMoney(saving)}`;
        } else {
          saveRow.textContent = '';
        }
      } else {
        return;
      }

      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set('variant', variant.id);
      window.history.replaceState(null, '', currentUrl);
    };

    const updateVariantDescription = function () {
      const variant = findVariant(selectedStyle, selectedPack);
      if (!variant) {
        return;
      }

      const descriptions = section.querySelectorAll('.main-product-variant-description');
      if (!descriptions.length) {
        return;
      }

      descriptions.forEach(function (node) {
        const variantId = node.getAttribute('data-variant-id');
        if (variantId === String(variant.id)) {
          node.classList.remove('hidden');
        } else {
          node.classList.add('hidden');
        }
      });
    };

    const updateSellingPlanInput = function () {
      if (!hiddenSellingPlanInput) {
        return;
      }

      if (selectedPlan === 'subscribe') {
        const selectedPlanId = frequencySelect?.value || '';
        hiddenSellingPlanInput.value = selectedPlanId;
      } else {
        hiddenSellingPlanInput.value = '';
      }
    };

    const renderGallery = function () {
      if (!mainGallery || !thumbsGallery || !mainSlides || !thumbSlides) {
        return;
      }

      const mainImgs = mainSlides.querySelectorAll('img[data-image-style]');
      const thumbImgs = thumbSlides.querySelectorAll('img[data-image-style]');
      let exactMatchCount = 0;

      mainImgs.forEach(function (img) {
        const style = (img.getAttribute('data-image-style') || '').trim();
        const pack = (img.getAttribute('data-image-pack') || '').trim();
        if (style && pack && style === selectedStyle && pack === selectedPack) {
          exactMatchCount += 1;
        }
      });

      const setSlideVisibility = function (imgNodes) {
        imgNodes.forEach(function (img) {
          const style = (img.getAttribute('data-image-style') || '').trim();
          const pack = (img.getAttribute('data-image-pack') || '').trim();
          const slide = img.closest('.swiper-slide');
          if (!slide) {
            return;
          }

          let shouldShow = true;
          if (exactMatchCount > 0) {
            if (style && pack) {
              if (style === selectedStyle && pack === selectedPack) {
                shouldShow = true;
              } else {
                shouldShow = false;
              }
            } else {
              shouldShow = true;
            }
          } else {
            shouldShow = true;
          }

          if (shouldShow) {
            slide.classList.remove('hidden');
          } else {
            slide.classList.add('hidden');
          }
        });
      };

      setSlideVisibility(mainImgs);
      setSlideVisibility(thumbImgs);

      if (mainSwiper && typeof mainSwiper.destroy === 'function') {
        mainSwiper.destroy(true, true);
      } else {
        mainSwiper = null;
      }

      if (thumbsSwiper && typeof thumbsSwiper.destroy === 'function') {
        thumbsSwiper.destroy(true, true);
      } else {
        thumbsSwiper = null;
      }

      thumbsSwiper = new Swiper(thumbsGallery, {
        spaceBetween: 10,
        slidesPerView: 'auto',
        freeMode: true,
        watchSlidesProgress: true,
        breakpoints: {
          320: {
            spaceBetween: 8
          },
          768: {
            spaceBetween: 10
          }
        }
      });

      mainSwiper = new Swiper(mainGallery, {
        spaceBetween: 10,
        navigation: {
          nextEl: galleryNext,
          prevEl: galleryPrev
        },
        thumbs: {
          swiper: thumbsSwiper
        }
      });
    };

    const updateAll = function () {
      syncStyleButtons();
      syncPlanUI();
      syncPackOptions();
      updatePriceArea();
      updateVariantDescription();
      updateSellingPlanInput();
      renderGallery();
    };

    const bindPackButtons = function (buttons) {
      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          const pack = button.getAttribute('data-pack-value') || '';
          if (pack) {
            selectedPack = pack;
            updateAll();
          } else {
            return;
          }
        });
      });
    };

    bindPackButtons(oneTimePackButtons);
    bindPackButtons(subscribePackButtons);

    styleButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        const nextStyle = button.getAttribute('data-style-value') || '';
        if (!nextStyle) {
          return;
        }

        selectedStyle = nextStyle;
        const variantForCurrentPack = findVariant(selectedStyle, selectedPack);
        if (!variantForCurrentPack) {
          const fallbackVariant = findVariant(selectedStyle, packValues[0]);
          if (fallbackVariant) {
            selectedPack = fallbackVariant.option2;
          } else {
            selectedPack = selectedPack;
          }
        } else {
          selectedPack = selectedPack;
        }

        updateAll();
      });
    });

    planToggleButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        const nextPlan = button.getAttribute('data-plan-toggle');
        if (nextPlan === 'subscribe' || nextPlan === 'one-time') {
          selectedPlan = nextPlan;
          updateAll();
        } else {
          return;
        }
      });
    });

    frequencySelect?.addEventListener('change', function () {
      updateSellingPlanInput();
    });

    form?.addEventListener('submit', function (event) {
      event.preventDefault();

      const variantId = hiddenVariantInput?.value;
      if (!variantId) {
        return;
      }

      const payload = {
        id: Number(variantId),
        quantity: 1
      };

      const sellingPlanId = hiddenSellingPlanInput?.value;
      if (selectedPlan === 'subscribe' && sellingPlanId) {
        payload.selling_plan = Number(sellingPlanId);
      } else {
        payload.selling_plan = undefined;
      }

      const submitButton = form.querySelector('.main-product-atc');
      if (submitButton) {
        submitButton.setAttribute('disabled', 'disabled');
      } else {
        return;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error(`Add to cart failed: ${response.status}`);
          } else {
            return response.json();
          }
        })
        .then(function () {
          if (typeof window.initCart === 'function') {
            window.initCart();
          } else if (document.getElementById('showCartDrawer')) {
            document.getElementById('showCartDrawer')?.click();
          } else {
            return;
          }
        })
        .catch(function (error) {
          console.error('main-product: add to cart error', error);
        })
        .finally(function () {
          if (submitButton) {
            submitButton.removeAttribute('disabled');
          } else {
            return;
          }
        });
    });

    updateAll();

    // Recommended products function
    fetch(window.Shopify.routes.root + `recommendations/products.json?product_id=${productData.id}&intent=complementary`)
    .then(response => {
      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.statusText}`);
      }
      return response.json();
    })
    .then(({ products }) => {
      const container = document.getElementById('product-recommendations');
      if (products.length > 0) {
        products.forEach(product => {
          let productPrice = currencyFormat((product.variants[0].price / 100).toFixed(2));

          let compareProductPrice = '';
          if (product.variants[0].compare_at_price !== null) {
            compareProductPrice = currencyFormat((product.variants[0].compare_at_price / 100).toFixed(2));
          }

          const productHtml = `
            <div class="swiper-slide border border-grey-50 bg-grey-25 rounded-2xl p-4">
              <div class="recommended-product flex items-center">
                <a href="${product.url}" class="flex-shrink-0 w-[80px] aspect-square rounded mr-4">
                  <img data-src="${product.featured_image}" src="${product.featured_image}" alt="${product.title}" class="lazyload w-full aspect-square object-contain object-center rounded"/>
                </a>
                <div class="flex gap-5 w-full items-center">
                  <div class="w-full">
                    <p class="text-charcoal-100 text-lg font-semibold leading-6">${product.title}</p>
                    <div class="flex items-center gap-1.5 pt-2.5">
                      <span class="text-grey-100 font-semibold line-through text-lg">${compareProductPrice}</span>
                      <span class="font-semibold text-charcoal-100 text-lg">${productPrice}</span>
                    </div>
                  </div>
                  <div class="cursor-pointer btn-primary-md w-[101px] max-md:hidden" onclick="quickBuyButton(${product.variants[0].id}, 1);">ADD</div>
                </div>
              </div>
              <div class="cursor-pointer btn-primary-md w-full mt-4 md:hidden" onclick="quickBuyButton(${product.variants[0].id}, 1);">ADD</div>
            </div>
          `;
          container.innerHTML += productHtml;
        });

        // Product recommendation slider
        const productRecommendations = new Swiper(".related-products-gallery", {
          slidesPerView: 1,
          loop: true,
          navigation: {
            nextEl: ".recommended-products .button-next",
            prevEl: ".recommended-products .button-prev",
          },
          pagination: {
            el: ".recommended-products .swiper-pagination",
            clickable: true,
          },
        });
      } else {
        document.querySelector('.recommended-products').classList.add('hidden');
      }
    })
    .catch(error => {
      console.error('There has been a problem with your fetch operation:', error);
    });
  };

  sections.forEach(function (section) {
    initSection(section);
  });

});
